import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import Pagination from "../../components/Pagination/pagination"
import ContenuLibre from "../../components/ContenuLibre/contenu-libre"
import {
  nePasManquerContainer,
  listPages,
  nePasManquerWrapper,
  zoneAnePasManquerLibreBas,
  zoneAnePasManquerLibreHaut,
} from "./styles/listPage.module.scss"
import PropTypes from "prop-types"
import { ContainerLight, StyledFade } from "./styled-components/pages-styled"
import SEO from "../../components/seo"
import NePasManquerItem from "./listItems/page-item"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query($skip: Int!, $limit: Int!) {
    allNodePage(
      sort: { fields: field_ordre, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      ...ListPages
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const NePasManquerTemplate = ({ data, pageContext }) => {
  const pageTitle = "Liste des pages"
  const { currentPage, numPages, baseLink } = pageContext
  return (
    <Layout message={pageTitle}>
      <SEO
        title={pageTitle}
        description="Dans cette page, vous découvrez la liste des pages"
      />
      <StyledFade childClassName={listPages} delay={150}>
        <section className={zoneAnePasManquerLibreHaut}>
          <ContenuLibre zoneTaxoLibre="zone_a_ne_pas_manquer_haut" />
        </section>
        <ContainerLight className={nePasManquerWrapper}>
          <div className={nePasManquerContainer}>
            <RenderNePasManquer nePasManquerData={data} />
          </div>
          <Pagination
            currentPage={currentPage}
            numPages={numPages}
            contextPage={baseLink}
          />
        </ContainerLight>
        <section className={zoneAnePasManquerLibreBas}>
          <ContenuLibre zoneTaxoLibre="zone_a_ne_pas_manquer_bas" />
        </section>
      </StyledFade>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderNePasManquer = ({ nePasManquerData }) => {
  return nePasManquerData.allNodePage.edges.map(({ node }) => {
    return <NePasManquerItem key={node.drupal_id} nePasManquer={node} />
  })
}

//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

NePasManquerTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
}
RenderNePasManquer.propTypes = {
  nePasManquerData: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default NePasManquerTemplate
